/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ContractHistoryEntry = {
  properties: {
    transactionId: {
      type: 'number',
    },
    time: {
      type: 'string',
      format: 'date-time',
    },
    statusBefore: {
      type: 'ContractStatus',
    },
    statusAfter: {
      type: 'ContractStatus',
    },
    userEmail: {
      type: 'string',
    },
    action: {
      type: 'HistoryAction',
    },
    order: {
      type: 'string',
    },
  },
} as const;
